import { resolve } from "ui-common/di";
import type { ICreatorLiveEventsService } from "./services/creator-live-events/types";
import type { ILiveEventFormService } from "ui-common/services/live-event-form/types";
import type { INotificationsService } from "ui-common/services/notifications/types";
import type { ICreatorProfileDataService } from "./services/creator-profile-data/types";
import type { IBackofficeFeatureFlagsService } from "./services/backoffice-feature-flags/types";
import type { ISubscriptionTierService } from "./services/subscription-tier/types";
import type { IBackofficePostsService } from "./services/backoffice-posts/types";
import type { IBackofficeWorldsService } from "./services/backoffice-worlds/types";
import type { IBackofficeLinksService } from "./services/backoffice-links/types";
import type { ILiveEventAccessRequestService } from "./services/live-event-access-request/types";
import type { ICreatorMessagesService } from "./services/creator-messages/types";
import type { ICreatorCommunitiesService } from "./services/creator-communities/types";

type RouterUser = { id: string; name: string; roles: [string] };

export function handleUserChange(user: RouterUser | undefined): void {
  const liveEventsService = resolve<ICreatorLiveEventsService>("creatorLiveEventsService");
  const liveEventFormService = resolve<ILiveEventFormService>("liveEventFormService");

  if (user) {
    const backofficeFeatureFlagsService = resolve<IBackofficeFeatureFlagsService>("backofficeFeatureFlagsService");
    backofficeFeatureFlagsService.loadFlags();

    const creatorProfileDataService = resolve<ICreatorProfileDataService>("creatorProfileDataService");
    creatorProfileDataService.loadProfile();

    const notificationsService = resolve<INotificationsService>("notificationsService");
    notificationsService.loadNotifications();

    const subscriptionTierService = resolve<ISubscriptionTierService>("subscriptionTierService");
    subscriptionTierService.loadTier();

    if (user.roles.includes("creator")) {
      const liveEventAccessRequestService = resolve<ILiveEventAccessRequestService>("liveEventAccessRequestService");
      liveEventAccessRequestService.loadRequestStatus();

      liveEventsService.loadEvents();
      liveEventFormService.initialize();

      const backofficePostsService = resolve<IBackofficePostsService>("backofficePostsService");
      backofficePostsService.loadPosts();

      const backofficeWorldsService = resolve<IBackofficeWorldsService>("backofficeWorldsService");
      backofficeWorldsService.loadWorlds();

      const backofficeLinksService = resolve<IBackofficeLinksService>("backofficeLinksService");
      backofficeLinksService.loadLinks();

      const creatorMessagesService = resolve<ICreatorMessagesService>("creatorMessagesService");
      creatorMessagesService.loadMessages();
    }
  } else {
    liveEventsService.clearCache();
    const creatorCommunitiesService = resolve<ICreatorCommunitiesService>("creatorCommunitiesService");
    creatorCommunitiesService.clearCache();
  }
}
